import { defineMessage } from 'services/localization';

export const messages = {
    emptyMessage: defineMessage('there_are_no_purchase_orders_to_match_with'),
    title: defineMessage('choose_a_purchase_order_and_the_respective_line'),
};
